export const openSocket = (url: string) => new WebSocket(url);
